export default __webpack_public_path__ + "static/media/about-firsthalf.6e3cc35c.png";